import cc from 'classcat';

import styles from './Headings.scss';

const cmp =
  (Tag, className) =>
  ({ className: cn, ...props }) => (
    <Tag className={cc([className, cn])} {...props} />
  );

export const H1 = cmp('h1', styles.h1);
export const H2 = cmp('h2', styles.h2);
export const H3 = cmp('h3', styles.h3);
export const H5 = cmp('h5', styles.h5);
